import { render, staticRenderFns } from "./LatestHomeworkSubmitCard.vue?vue&type=template&id=c77683a4&scoped=true"
import script from "./LatestHomeworkSubmitCard.vue?vue&type=script&lang=ts"
export * from "./LatestHomeworkSubmitCard.vue?vue&type=script&lang=ts"
import style0 from "./LatestHomeworkSubmitCard.vue?vue&type=style&index=0&id=c77683a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77683a4",
  null
  
)

export default component.exports